import zod from 'zod';
var CompletedTestStepSchema = zod.object({
    snr: zod.number(),
    challenge: zod.array(zod.number()),
    response: zod.array(zod.number()),
    passed: zod.boolean(),
    timestamp: zod.number(),
});
export function validateTestSteps(steps) {
    if (!steps.every(function (step) {
        return CompletedTestStepSchema.parse(step);
    })) {
        throw new Error('Cannot send test to leads. Test is incomplete');
    }
}
